import React from 'react';
import PropTypes from 'prop-types';

const DiscPassword = ({ color = '#8C949C', number = 1 }) => {
    const result = [];
    for (let i = 0; i < number; i += 1) {
        result.push(
            <svg
                key={`discpsw-${i}`}
                viewBox="0 0 160 400"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="
        M 80, 240
        m -60, 0
        a 60,60 0 1,0 120,0
        a 60,60 0 1,0 -120,0
        "
                    fill={color}
                    fillRule="evenodd"
                />
            </svg>,
        );
    }
    return result;
};

DiscPassword.propTypes = {
    color: PropTypes.string,
    number: PropTypes.number,
};

export default DiscPassword;
